'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_ui_Markdown$Block() {
}
export { $c_Lio_intela_sites_intelacloud_ui_Markdown$Block as $c_Lio_intela_sites_intelacloud_ui_Markdown$Block };
$p = $c_Lio_intela_sites_intelacloud_ui_Markdown$Block.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_ui_Markdown$Block;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_ui_Markdown$Block() {
}
export { $h_Lio_intela_sites_intelacloud_ui_Markdown$Block as $h_Lio_intela_sites_intelacloud_ui_Markdown$Block };
$h_Lio_intela_sites_intelacloud_ui_Markdown$Block.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=io.intela.sites.intelacloud.ui.-Markdown$-Block.js.map
